import * as React from 'react';

export default class DpsTwitterContainer extends React.PureComponent {
  public render() {
    return (
      <div className="twitter-container featured card">
        <div className="twitter-embed">
          <iframe src="https://widgets.sociablekit.com/twitter-feed/iframe/25698339" frameBorder="0" width="100%"></iframe>
        </div>
      </div>
    );
  }
}
